import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_defaultDispatcher() {
  return Dispatchers_getInstance().b14_1;
}
//region block: exports
export {
  get_defaultDispatcher as get_defaultDispatcher3rblue9uzsji2,
};
//endregion

//# sourceMappingURL=dispatchers.js.mjs.map
